import RejectIcon from '../../../assets/images/reject-icon.svg'
import ReviewIcon from '../../../assets/images/review-icon.svg'
import SuccessIcon from '../../../assets/images/success-icon.svg'

export const StatusType = {
    '0':0,
    '1':1,
    '2':2,
};

export const StatusText = {
    '0':'reviewing',
    '1':'approved',
    '2':'rejected',
};

export const ICON_MAPPING = {
    '0':ReviewIcon,
    '1':SuccessIcon,
    '2':RejectIcon
}

export const STATUS_CONFIG = {
  '0': {
    title: "Our team is reviewing your submission",
    description:
      "This usually takes 2–3 business days. We'll notify you once the review is complete.",
    des_key:'tv_process_desc',
    titleKey:'our_team_is_reviewing_your_submission',
  },
  '1': {
    title: "Documentation approved",
    description: "Your document has been approved. You may now proceed for the assessment.",
    des_key:'approve_desc',
    titleKey:'documentation_approved',
  },
  '2': {
    title: "Documentation Not Approved.",
    description:
      "Your submitted documents do not meet the required criteria. Please upload the documents as per the guidelines and resubmit..",
    des_key:'tv_reject_desc',
    titleKey:'documentation_not_approved',
  },
};

export const WEIGHTAGE = [
        { value: 60, label: "Course Completion" , key:'course_completion' },
        { value: 10, label: "Screening & TLM Upload" , key:'screening_tlm_upload' },
        { value: 30, label: "Final Assessment" , key:'final_assessment' },
]